export default __webpack_public_path__ + "static/media/dbd_yellow.8ceeab3d.png";